import { LoadingLayout } from 'components';
import { useScrollToTop } from 'hooks/useScrollToTop';
import { ErrorFallback } from 'modules/App/ErrorFallback';

import { getLegalClientHeadMainInfo } from '../helpers';
import { useLegalClientHead } from '../hooks';
import { LegalClientHeadView } from '../views/LegalClientHeadView';

export const LegalClientHeadContainer = () => {
  const {
    loading,
    legalClientHead,
    legalClient,
    countries,
    countriesLoading,
    error,
    initialValues,
    submitLoading,
    breadcrumbsTitles,
    deleteLoading,
    resendVerificationEmailTime,
    changeEmailLoading,
    changeEmailError,
    archiveLoading,
    dearchiveLoading,
    revokeOtpVerificationLoading,
    onChangeEmail,
    lockClientIfPossible,
    unlockClient,
    onSubmit,
    onShowVersionHistory,
    onDelete,
    onSendVerificationEmail,
    onArchive,
    onDearchive,
    onRevokeOtpVerification,
  } = useLegalClientHead();

  useScrollToTop([]);

  if (error || (!legalClientHead && !loading)) {
    return <ErrorFallback />;
  }

  if (loading || !legalClientHead) {
    return <LoadingLayout />;
  }

  const mainInfo = getLegalClientHeadMainInfo(legalClientHead);

  return (
    <LegalClientHeadView
      archiveLoading={archiveLoading}
      bodies={legalClient?.bodies ?? []}
      breadcrumbsTitles={breadcrumbsTitles}
      changeEmailError={changeEmailError}
      changeEmailLoading={changeEmailLoading}
      countries={countries}
      countriesLoading={countriesLoading}
      dearchiveLoading={dearchiveLoading}
      deleteLoading={deleteLoading}
      initialValues={initialValues}
      kycData={legalClientHead.kyc}
      lockClientIfPossible={lockClientIfPossible}
      mainInfo={mainInfo}
      resendVerificationEmailTime={resendVerificationEmailTime}
      revokeOtpVerificationLoading={revokeOtpVerificationLoading}
      submitLoading={submitLoading}
      unlockClient={unlockClient}
      onArchive={onArchive}
      onChangeEmail={onChangeEmail}
      onDearchive={onDearchive}
      onDelete={onDelete}
      onRevokeOtpVerification={onRevokeOtpVerification}
      onSendVerificationEmail={onSendVerificationEmail}
      onShowVersionHistory={onShowVersionHistory}
      onSubmit={onSubmit}
    />
  );
};
